import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Sidebar.css";
import logo from "../../assets/logo.svg";

const Sidebar = ({ selectedPremise }) => {
  console.log("selectedSideBarPremise--->", selectedPremise);
  const showScheduler =
    selectedPremise?.scheduler_feature == "true" ? true : false;

  const showWorkLocation =
    selectedPremise?.work_location_feature == "true" ? true : false;

  const showBreakAndViolation =
    selectedPremise?.breaks_and_violations_feature == "true" ? true : false;

  const showPayrollIntegration =
    selectedPremise?.payroll_integration == "true" ? true : false;

  const menuItems = [
    { iconClass: "fas fa-home", label: "Dashboard", path: "/dashboard" },
    { iconClass: "fas fa-city", label: "Premises", path: "/premises" },
    { iconClass: "fas fa-users", label: "Users", path: "/users" },
    showScheduler && {
      iconClass: "fas fa-user-clock",
      label: "WorkShifts",
      path: "/workshift",
      subMenu: [
        {
          iconClass: "fa-regular fa-clock",
          label: "Define Shift",
          path: "/workshift/defineshifts",
        },
        {
          iconClass: "fa-solid fa-calendar-check",
          label: "Staff Shifts",
          path: "/workshift/staffshifts",
        },
      ],
    },
    showWorkLocation && {
      iconClass: "fas fa-map-marker-alt",
      label: "WorkLocations",
      path: "/worklocation",
      subMenu: [
        {
          iconClass: "fa-regular fa-clock",
          label: "Define Locations",
          path: "/worklocation/definelocation",
        },
        {
          iconClass: "fa-solid fa-calendar-check",
          label: "Assign Locations",
          path: "/worklocation/assignlocationtostaff",
        },
      ],
    },
    {
      iconClass: "fas fa-chart-bar",
      label: "Reports",
      path: "/report",
      subMenu: [
        {
          iconClass: "fa-regular fa-clock",
          label: "Timing",
          path: "/report/timing",
        },
        {
          iconClass: "fa-solid fa-calendar-check",
          label: "Leave",
          path: "/report/leave",
        },
        {
          iconClass: "fa-solid fa-calendar-plus",
          label: "Time Permission",
          path: "/report/timepermission",
        },
        showBreakAndViolation && {
          iconClass: "fa-solid fa-mug-saucer",
          label: "Breaks & Violations",
          path: "/report/break-violation",
        },
      ].filter(Boolean),
    },
    {
      iconClass: "fas fa-gear",
      label: "Settings",
      path: "/settings",
      subMenu: [
        {
          iconClass: "fas fa-calendar-check",
          label: "Leave Policy",
          path: "/settings/time-off/policy",
        },
        showPayrollIntegration && {
          iconClass: "fas fa-user-tie",
          label: "Payroll",
          path: "/settings/payroll",
        },
        showBreakAndViolation && {
          iconClass: "fas fa-clipboard-list",
          label: "Breaks & Violations",
          path: "/settings",
        },
        {
          iconClass: "fas fa-project-diagram",
          label: "API Settings",
          path: "/settings/api",
        },
      ].filter(Boolean),
    },
    // { iconClass: "fas fa-robot", label: "AI", path: "/ai" },
    // Account-related menu
    {
      iconClass: "fas fa-user", // Gear icon for settings/account
      label: "Account",
      path: "/account",
      subMenu: [
        {
          iconClass: "fas fa-user-circle", // Calendar-check icon for profile
          label: "Profile",
          path: "/account/profile",
        },
        // Payment Gateway Functionality Start

        // {
        //   iconClass: "fas fa-money-bill-wave", // Clipboard-list icon for payments
        //   label: "Payments",
        //   path: "/account/payments",
        // },
        // {
        //   iconClass: "fas fa-money-bill-wave", // Clipboard-list icon for payments
        //   label: "Subscription",
        //   path: "/account/subscription",
        // },

        // Payment Gateway Functionality End
      ],
    },
  ].filter(Boolean);

  console.log("showScheduler--->", selectedPremise);
  console.log("showScheduler123--->", showScheduler);
  const location = useLocation();
  const [activePath, setActivePath] = useState(location.pathname);
  const [expandedMenus, setExpandedMenus] = useState({
    Reports: true, // Default to open
    Settings: true, // Default to open
    Account: true,
    WorkShifts: true,
    WorkLocations: true,
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 1025); // Open by default on large screens

  useEffect(() => {
    setActivePath(location.pathname);

    // Automatically adjust sidebar state on resize
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth > 1025);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [location]);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };
  const navigate = useNavigate();

  useEffect(() => {
    setActivePath(location.pathname);

    localStorage.removeItem("startWorkHours");
    localStorage.removeItem("startWorkMins");
    localStorage.removeItem("startWorkMins1");

    localStorage.removeItem("violationHours");
    localStorage.removeItem("violationMins");
    localStorage.removeItem("breakMinTime");

    if (activePath !== "/settings") {
      localStorage.removeItem("currentStep");
      localStorage.removeItem("selectedPolicyPremise");
      localStorage.removeItem("selectedPolicy");
    }
    if (activePath !== "/report/break-violation") {
      localStorage.removeItem("currentBreakStep");
      localStorage.removeItem("selectedBreakPremise");
      localStorage.removeItem("breakPremise");
    }
    // localStorage.removeItem("stepUserOneData");
    // localStorage.removeItem("stepUserTwoData");
  }, [location, activePath]);

  const handleLogoClick = () => {
    navigate("/dashboard");
  };

  const toggleSubMenu = (label) => {
    console.log("Label-->", label);
    setExpandedMenus((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  return (
    <>
      {/* Sidebar Toggle Button for Tablets and Below */}
      {!isSidebarOpen && (
        <button className="sidebar-toggle-btn" onClick={toggleSidebar}>
          ☰
        </button>
      )}
      <div
        className={`sidebar bg-gradient ${isSidebarOpen ? "open" : "closed"}`}
      >
        <div className="sidebarDiv">
          <div className="sidebarLogoDiv text-center">
            <img
              src={logo}
              alt="Logo"
              className="sideBarLogoImage"
              style={{ cursor: "pointer" }}
              onClick={handleLogoClick}
            />
            {isSidebarOpen && (
              <button className="close-sidebar-btn" onClick={toggleSidebar}>
                <i className="fas fa-chevron-left"></i>
              </button>
            )}
          </div>
          <div className="sidebarListDiv">
            <ul className="list-unstyled">
              {menuItems.map((item, index) => {
                const isActive =
                  activePath === item.path ||
                  (item.path === "/users" &&
                    activePath.includes("/user/statistics")) ||
                  (item.path === "/users" &&
                    activePath.includes("/user/create")) ||
                  (item.path === "/users" &&
                    activePath.includes("/user/update")) ||
                  (item.path === "/premises" &&
                    activePath.includes("/premises")) ||
                  (item.path === "/premises" &&
                    activePath.includes("/premise/create")) ||
                  (item.path === "/premises" &&
                    activePath.includes("/premise/update")) ||
                  (item.path === "/report" && activePath.includes("/report")) ||
                  (item.path === "/settings" &&
                    activePath.includes("/settings")) ||
                  (item.path === "/account" &&
                    activePath.includes("/account")) ||
                  (item.path === "/workshift" &&
                    activePath.includes("/workshift")) ||
                  (item.path === "/worklocation" &&
                    activePath.includes("/worklocation"));
                const hasSubMenu = !!item.subMenu;

                console.log("hasSubMenu--->", hasSubMenu);

                return (
                  <React.Fragment key={index}>
                    <li
                      className={`menu-item ${isActive ? "active" : ""}`}
                      onClick={() => hasSubMenu && toggleSubMenu(item.label)}
                    >
                      <Link
                        to={hasSubMenu ? "#" : item.path}
                        className="d-flex align-items-center"
                      >
                        <i className={`${item.iconClass} me-2`}></i>
                        <span className="labelSpan">
                          {item.label === "WorkShifts"
                            ? "Work Shifts"
                            : item.label === "WorkLocations"
                            ? "Work Locations"
                            : item.label}
                        </span>
                        {/* {hasSubMenu && (
                        <i
                          className={`ms-auto expand-icon fas ${
                            expandedMenus[item.label] ? "fa-minus" : "fa-plus"
                          }`}
                        ></i>
                      )} */}
                      </Link>
                    </li>
                    {hasSubMenu && expandedMenus[item.label] && (
                      <ul className="submenu ps-3">
                        {item.subMenu.map((subItem, subIndex) => {
                          const isSubActive =
                            activePath === subItem.path ||
                            (subItem.path === "/settings/time-off/policy" &&
                              activePath.startsWith(
                                "/settings/time-off/policy"
                              )) ||
                            (subItem.path === "/account" &&
                              activePath.startsWith("/account")) ||
                            (subItem.path === "/workshift" &&
                              activePath.startsWith("/workshift")) ||
                            (subItem.path === "/worklocation" &&
                              activePath.startsWith("/worklocation"));

                          console.log("isSubActive--->", isSubActive);
                          return (
                            <li
                              key={subIndex}
                              className={`submenu-item d-flex align-items-center ${
                                isSubActive ? "active" : ""
                              }`}
                            >
                              <i
                                className={`${subItem.iconClass} me-2`}
                                style={{
                                  marginLeft:
                                    subItem.iconClass ===
                                      "fa-regular fa-clock" ||
                                    subItem.iconClass ===
                                      "fas fa-clipboard-list"
                                      ? "3px"
                                      : "0",
                                  marginTop:
                                    subItem.iconClass ===
                                      "fas fa-clipboard-list" ||
                                    subItem.iconClass ===
                                      "fas fa-calendar-check"
                                      ? "-5px"
                                      : "0",
                                }}
                              ></i>
                              <Link to={subItem.path}>{subItem.label}</Link>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </React.Fragment>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
